import { render, staticRenderFns } from "./DashboardNeopag.vue?vue&type=template&id=c074a56e&"
import script from "./DashboardNeopag.vue?vue&type=script&lang=js&"
export * from "./DashboardNeopag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports